import { useState } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import axios from "axios";

import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";

const OrgResetPasswordScreen = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const navigate = useNavigate();
  const { resetToken } = useParams();

  const resetPasswordHandler = async (e) => {
    e.preventDefault();

    const config = {
      header: {
        "Content-Type": "application/json",
      },
    };

    if ( password !== confirmPassword ) {
      setPassword("");
      setConfirmPassword("");
      window.alert("Passwords do not match.");
    }

    await axios.post(
      `/auth/org-reset-password/${resetToken}`,
      {
        password,
      },
      config
    ).then(
      () => {
        window.alert("Password reset successful.");
        navigate("/org-login");
      }
    ).catch(
      () => {
        window.alert("Password reset failed.");
      }
    );
  };

  return (
    <Container className="auth-page">
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <Card className="auth-card">
            <Card.Body>
              <Form onSubmit={resetPasswordHandler}>
                <h3 className="page-title">Organisation Reset Password</h3>
                <p className="page-subtitle mb-4">Set a new password for your organisation account.</p>
                <Form.Group className="mb-3" controlId="formPassword">
                  <Form.Label>New Password</Form.Label>
                  <Form.Control type="password" required placeholder="Enter new password" autoComplete="true" value={password} onChange={(e) => setPassword(e.target.value)} tabIndex={1}/>
                </Form.Group>
                <Form.Group className="mb-4" controlId="formConfirmPassword">
                  <Form.Label>Confirm New Password</Form.Label>
                  <Form.Control type="password" required placeholder="Confirm new password" autoComplete="true" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} tabIndex={2}/>
                </Form.Group>
                <Button variant="primary" type="submit" tabIndex={3}>
                  Reset Password
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default OrgResetPasswordScreen;
